
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  import { TDashboardRegionFilter, TDashboardRegionFilterPayload } from '@/modules/ves/types/regionDashboards';

  import {
    REGION_DASHBOARDS_VES_ACTIONS_NAME,
    REGION_DASHBOARDS_VES_GETTERS_NAME,
  } from '../../../store/regionDashboards/name';
  import DateActualDataSubtitle from '../../common/DateActualDataSubtitle.vue';
  import DashboardsCardsWrapper from '../DashboardsCardsWrapper.vue';
  import RegionDashboardsDynamicCard from './RegionDashboardsDynamicCard.vue';

  export default defineComponent({
    name: 'RegionDashboardsDynamicCards',
    components: {
      RegionDashboardsDynamicCard,
      DashboardsCardsWrapper,
      DateActualDataSubtitle,
    },
    props: {
      filter: {
        type: Object as PropType<TDashboardRegionFilter>,
        required: true,
      },
    },
    data: (): { dynamicCardsAbortController: AbortController | null; isLoading: boolean } => ({
      dynamicCardsAbortController: null,
      isLoading: false,
    }),
    computed: {
      ...mapGetters({ dynamicCards: REGION_DASHBOARDS_VES_GETTERS_NAME.getDynamicCards }),
      getPreparedFilter(): TDashboardRegionFilter {
        return {
          year: this.filter.year,
          regionRfId: this.filter.regionRfId,
        };
      },
    },
    methods: {
      ...mapActions({ getDynamicCards: REGION_DASHBOARDS_VES_ACTIONS_NAME.getDynamicCards }),
    },
    watch: {
      filter: {
        async handler() {
          this.dynamicCardsAbortController?.abort();
          this.dynamicCardsAbortController = new AbortController();

          const payload: TDashboardRegionFilterPayload = {
            params: this.getPreparedFilter,
            abortController: this.dynamicCardsAbortController,
          };

          this.isLoading = true;
          await this.getDynamicCards(payload);
          this.isLoading = false;
        },
        immediate: true,
      },
    },
  });
